export default __webpack_public_path__ + "static/media/web-Bim-Share-1.a1d4a57f.png";